<template>
  <vx-card :title="title">
    <div v-show="visibleRes">
      <Actions
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result.length">
        <div ref="contentPdf">
          <div v-for="(item,i) in result" :key="i">
            <div class="text-2xl font-bold text-red-400 my-5">{{ item[groupByFilters(form.getFieldValue('group_by'))] }}</div>
            <div v-for="(matter,index) in item.matters" :key="index">
              <div class="font-medium my-5">{{ matter.name }}</div>
              <a-table :dataSource="matter.bills" :columns="columns" :pagination="false" :scroll="{ x: true }" class="tbl-receivable">
                <span slot="bill_id" slot-scope="text,record">
              <a href="#" @click="$router.push(`/billing/dashboard/${record.id}`)">{{ record.factor_no }}</a>
            </span>
                <span slot="due_date" slot-scope="text,record">
                   {{ setDateFormat(record.due_date) }}
                </span>
                <span slot="status" slot-scope="text,record">
                  <template v-if="record.status === 1">Draft</template>
                  <template v-if="record.status === 2">Approved</template>
                  <template v-if="record.status === 3">UnPaid</template>
                  <template v-if="record.status === 4">Paid</template>
                </span>
                <span slot="balance" slot-scope="text,record">
                 {{ (record.total_amount - record.payed_amount).toFixed(2) }}
                </span>
                <template slot="footer">
                  <template v-if="matter.bills.length">
                    <div class="flex gap-4">
                      <div class="font-bold">Total:</div>
                      <div class="grid grid-cols-6 xl:grid-cols-5 gap-4 flex-1">
                        <div class="col-span-2 xl:col-span-1">{{ currencySymbol + sumCol(matter.bills,'total_amount') }}</div>
                        <div class="col-span-2 place-self-center">{{ currencySymbol + sumCol(matter.bills,'payed_amount') }}</div>
                        <div class="col-span-2 place-self-center">{{ currencySymbol + sumCol(matter.bills,'balance','general') }}</div>
                      </div>
                    </div>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
          <slot></slot>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <div v-show="!visibleRes">
      <a-form :form="form" @submit.prevent="handleReport">
        <div class="grid grid-cols-1 w-full md:w-1/2">
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Responsible Lawyer">
              <a-radio-group v-decorator="['which_user',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleChangeUser">
                <a-radio :style="radioStyle" :value="1">
                  All Lawyers
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Responsible Lawyer
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <SelectOption
              v-show="user_value === 2"
              url="/account/list/"
              label="User"
              field="user"
              :required="false"
              method="get"
              mode="multiple"
              placeholder="Find A User"
              class="self-end w-full md:w-1/2"
            />
          </div>
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Client/Matter">
              <a-radio-group v-decorator="['which_client_matter',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleMatterClient">
                <a-radio :style="radioStyle" :value="1">
                  All Clients
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Specific Client
                </a-radio>
                <a-radio :style="radioStyle" :value="3">
                  Specific Matter
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <selectSearch
              v-show="checked_matter_client === 3"
              :required="false"
              url="/matter/query/"
              :options="optionSearchMatter"
              class="self-end mt-0 w-full md:w-1/2"
              :is_include_matter="true"
              @selectSearch="handleSearch"
              placeholder="Enter Name Of Matter"
            />
            <selectSearch
              v-show="checked_matter_client === 2"
              :required="false"
              url="/contact/query/"
              :options="optionSearchContact"
              class="self-center mt-0 w-full md:w-1/2"
              :is_include_matter="false"
              @selectSearch="handleSearch"
              placeholder="Enter Name Of Client"
            />
          </div>
          <a-form-item label="Group Results By">
            <a-select v-decorator="['group_by',{ initialValue: 1,rules: [{ required: true, message: 'this field is required.' }] }]">
              <a-select-option :value="1">
                Client
              </a-select-option>
              <a-select-option :value="2">
                Practice Area
              </a-select-option>
              <a-select-option :value="3">
                Lawyer
              </a-select-option>
            </a-select>
          </a-form-item>
          <SelectOption url="/dictionary/practice-area/" label="Practice Area" placeholder="Practice Area" field="practice_area" method="get"/>
          <DateRangeComponent class="mt-4" :dateForm="form"></DateRangeComponent>
        </div>
        <BtnSubmitReport
          ref="reportSubmit"
          @backPage="$emit(title === 'Accounts Receivable' ? 'changeTab' : 'componentLedgerBack','BillingReport')"
        />
      </a-form>
    </div>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      :pdfForm="form.getFieldsValue(['from_date','to_date'])"
      @onProgress="onProgress"
      @hasDownloaded="hasDownloaded"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>

<script>

import SelectOption from '../../forms/SelectOptionSingle'
import selectSearch from '../../forms/selectSearch'
import axios from '@/axios'
import mixin from '../../mixin/mixin'
import Template from "@/views/template/Template";
import DateRangeComponent from "@/components/date/DateRangeComponent";
import Actions from "@/components/closeDownloadReport/Actions";
import ExportPdf from "@/components/pdf/ExportPdf";
import ModalProgress from "@/components/modalProgress/ModalProgress";
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";

const columns = [
  {
    title: 'Bill id',
    dataIndex: 'bill_id',
    key: '1',
    scopedSlots: { customRender: 'bill_id' },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: '2',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: 'Due Date',
    dataIndex: 'due_date',
    key: '3',
    scopedSlots: { customRender: 'due_date' },
  },
  {
    title: 'Amount',
    dataIndex: 'total_amount',
    key: '4',
  },
  {
    title: 'Payment',
    dataIndex: 'payed_amount',
    key: '5',
  },
  {
    title: 'Balance',
    dataIndex: 'note',
    key: '7',
    scopedSlots: { customRender: 'balance' },
  },
];


export default {
  name: "ComponentGeneral",
  mixins:[mixin],
  props: {
    title: {
      type: String,
      default: 'Accounts Receivable'
    }
  },
  components:{
    BtnSubmitReport,
    ModalProgress,
    ExportPdf,
    Actions,
    DateRangeComponent,
    Template,
    SelectOption,
    selectSearch
  },
  data(){
    return{
      user_value: null,
      checked_matter_client: null,
      columns,
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '30px',
      },
    }
  },
  computed: {
    currencySymbol() {
      return localStorage.getItem('currency_symbol')
    },
  },
  methods:{
    handleChangeUser({target:{value}}){
      if (value === 1)
        this.form.setFieldsValue({ user: [] })
      this.user_value = value
    },
    handleMatterClient({target:{value}}){
      this.checked_matter_client = value
      if (value === 3) this.form.resetFields('contact')
      if (value === 2) this.form.resetFields('matter')
    },
    handleReport(){
      this.form.validateFields(async (err,values)=>{
        if(!err){
          try {
            //this.user_value === 2
            this.$refs.reportSubmit.loading = true
            const query     = []
            if (values.matter)  query.push({ field:'matters', condition: '=', value: values.matter })
            if (values.contact) query.push({ field:'to_contact', condition: '=', value: values.contact })
            if (values.practice_area) query.push({ field:'matters__practice_area', condition: '=', value: values.practice_area })
            if (values.user && values.user.length) query.push({ field:'matters__responsible', condition: 'in', value: values.user })
            if (values.from_date && values.to_date) query.push({ field:'due_date', condition: '>=', value: values.from_date },{ field:'due_date', condition: '<=', value: values.to_date })
            const {data}    = await axios.post('billing/report/receivable/',{
              group_by: values.group_by,
              query   : query.length ? query : undefined,
            })
            // from    : values.from_date,
            //   to      : values.to_date
            // from: values.from_date,to:values.to_date,
            this.visibleRes = true
            this.result     = Object.values(data)
            this.$emit('result',this.result)
            //this.checked_matter_client = 1
          }catch (e) {
            this.visibleRes = false
            throw new Error(e)
          }finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    },
  }
}
</script>

<style lang="less">
@import "../../style/style.css";
//.ant-table-footer {
 // @apply w-full xl:w-1/2 ml-auto;
//}
</style>
